import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'md-modal-title',
  templateUrl: './modal-title.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalTitleComponent {}
